import { render, staticRenderFns } from "./Invalid.vue?vue&type=template&id=552f752d&"
import script from "./Invalid.vue?vue&type=script&lang=js&"
export * from "./Invalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VResponsive})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552f752d')) {
      api.createRecord('552f752d', component.options)
    } else {
      api.reload('552f752d', component.options)
    }
    module.hot.accept("./Invalid.vue?vue&type=template&id=552f752d&", function () {
      api.rerender('552f752d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Invalid.vue"
export default component.exports